import React from "react";
import { Navigate } from "react-router-dom";
import { getItem } from "../utils/nauth";

export const AdminGate = ({ children }: { children: JSX.Element }) => {
  if (getItem("role") !== "admin") {
    return <Navigate replace to="/templates" />;
  }
  return children;
};

export default AdminGate;
